import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Router from "./Router";
import { muiTheme } from "./theme";

function App() {
  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <Router />
    </ThemeProvider>
  );
}

export default App;
